package com.devi3east.bashbuddy.features.common.util

import kotlinx.browser.document

actual fun dismissPlatformPreloader() {
    document.getElementById("preloader")?.remove()
}